import { DataResponse, SurchargeBanConfig } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const surchargeBanService = createApi({
  reducerPath: "surchargeBanService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getSurchargeBanRules: builder.query<DataResponse<SurchargeBanConfig>, void>({
      query: () => ({
        url: `/surcharge-ban/rules`,
        method: "GET",
        headers: {
          PageName: "Surcharge Ban Setting",
        },
      }),
    }),
  }),
});

export const { useGetSurchargeBanRulesQuery } = surchargeBanService;
